export default class OrderUnitModel {
    constructor(data, salesInfo) {
        this.salesInfo = salesInfo;

        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {

    }

    customizeOption = (element, model) => {
        var contentQty = model.PriceUnitQuantityFormatted(),
            //hide the longer string in the order unit field after selection
            hideClass = model.OrderUnitText() ? "hide-long-unit" : "";

        var subText = contentQty ? `<div class="price-unit ${hideClass}">${contentQty}</div>` : "";
        $(element).attr('data-content', `<div class="unit"><div>${model.UnitName()}</div> ${subText}</div>`);
    };

    //subOrderUnitVisible = ko.computed(() => {
    //    return this.OrderUnitText().length !== 0
    //        ? this.PriceUnitQuantityFormatted().length > 0
    //        : false;
    //});

    readonly = () => this.IsExtendedUnit();

    adjustQuantity = (value) => {
        if (this.Interval()) {
            value = Math.floor(value / this.Interval()) * this.Interval();

            if (value === 0) {
                value = this.Interval();
            }
        }

        if (this.MaxQuantity() && value > this.MaxQuantity()) {
            value = this.MaxQuantity();
        }

        if (this.MinQuantity() && value < this.MinQuantity()) {
            value = this.MinQuantity();
        }

        return value;
    };

    #displayType = ko.observable();
    quantity = ko.observable();

    onQuantityValidate = () => {
        var value = parseFloat(this.quantity());
        value = this.adjustQuantity(value);

        this.quantity(value);
    };

    inputTpl = ko.pureComputed(() => {
        if (this.readonly() || this.#displayType() || this.salesInfo.QuantityDisplayType() === 1) {
            return 'qty-input-tpl';
        } else {
            return 'qty-select-tpl';
        }
    });

    hint = (min, max, int) => {
        let hint = [];

        if (this.MinQuantity() > 1) {
            hint.push(`${min} ${this.MinQuantity()}`);
        }
        if (this.MaxQuantity() > 0) {
            hint.push(`${max} ${this.MaxQuantity()}`);
        }
        if (this.Interval() > 0) {
            hint.push(`${int} ${this.Interval()}`);
        }

        return hint.join(", ");
    };
}